import React from "react";
import { BrowserRouter } from "react-router-dom";
import Routes from "./Routes";
import { ThemeProvider } from "./context/ThemeContext";
import { AuthProvider } from "./contexts/AuthContext";
import { AIAgentProvider } from "./contexts/AIAgentContext";
import AIAgentOverlay from "./components/AIAgentOverlay";
import SignUpPrompt from "./components/SignUpPrompt";

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <AuthProvider>
          <AIAgentProvider>
            <Routes />
            <AIAgentOverlay />
            <SignUpPrompt />
          </AIAgentProvider>
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
